import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import Swal from "sweetalert2";
import * as Yup from "yup";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import {
  getVerifyAddress,
  updatePermanentAddress,
  getAddressByPincode,
  getRequestTypeStage,
  getRequestTypeDocs,
  addAddressKra,
} from "designs/v1/pages/ModifyKyc/services";
import {
  isEmptyObject,
  validateOnNumber,
  validateOnPaste,
  onInputToUpperCase,
} from "utils";

const PermanentAddressForm = ({
  stageScreen,
  setStageScreen,
  activeUserDetail,
  setStep,
  isLoading,
  setIsLoading,
}) => {
  const timeout = useRef();
  const [verifyAddress, setVerifyAddress] = useState(null);
  const [initialValues, setInitialValues] = useState({
    is_address_modified: "0",
    is_corr_and_perm_address_same: "",
    permanent_address: {
      address_line1: "",
      city: "",
      pincode: "",
      state: "",
      country: "INDIA",
    },
    communication_address: {
      address_line1: "",
      city: "",
      pincode: "",
      state: "",
      country: "INDIA",
    },
  });
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    if (!verifyAddress) return;
    console.log("activeUserDetail", activeUserDetail);
    const loadAddressInfo = async () => {
      setIsLoading(true);
      try {
        const resp = await getAddressByPincode({
          pincode: verifyAddress.pincode,
        });
        const data = resp.data.data;
        setInitialValues({
          ...initialValues,
          permanent_address: {
            ...initialValues.permanent_address,
            address_line1: verifyAddress.address_line1,
            pincode: verifyAddress.pincode,
            city: data.DistrictName || "",
            state: data.StateName || "",
          },
          communication_address: activeUserDetail.communication_address?.[0],
        });
        setIsLoading(false);
      } catch (error) {
        setInitialValues({
          ...initialValues,
          permanent_address: verifyAddress,
          communication_address: activeUserDetail.communication_address?.[0],
        });
        setIsLoading(false);
      }
    };
    loadAddressInfo();
  }, [verifyAddress]);

  useEffect(() => {
    setIsLoading(true);
    const loadVerifyAddress = async () => {
      let payload = {
        doc_name: localStorage.getItem("AddressRequestNumber"),
      };
      try {
        const resp = await getVerifyAddress(payload);
        console.log(resp.data.data);
        setVerifyAddress(resp.data?.data);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    };
    loadVerifyAddress();
  }, []);

  const handleValidate = (values) => {
    const errors = {};
    if (!values.permanent_address.address_line1) {
      errors.permanent_address = "Required";
    }
    if (!values.permanent_address.pincode) {
      errors.permanent_address = "Required";
    }
    if (!values.permanent_address.city && !values.permanent_address.city) {
      errors.permanent_address = "Required";
    }
    // if (values.is_corr_and_perm_address_same == "0") {
    //   if (!values.communication_address.address_line1) {
    //     errors.communication_address = "Required";
    //   }
    //   if (!values.communication_address.pincode) {
    //     errors.communication_address = "Required";
    //   }
    //   if (!values.communication_address.city && !values.communication_address.city) {
    //     errors.communication_address = "Required";
    //     errors.communication_address = "Required";
    //   }
    // }
    console.log("errors", errors);
    return errors;
  };

  const checkIsAddressChanged = (value) => {
    let modified = "0";
    if (
      value.permanent_address.address_line1 !== verifyAddress.address_line1 ||
      value.permanent_address.pincode !== verifyAddress.pincode
    ) {
      modified = "1";
    }
    return modified;
  };

  const handleSubmit = async (value) => {
    setIsLoading(true);
    let isAddressModified = checkIsAddressChanged(value);
    let payload = {
      ...value,
      is_address_modified: isAddressModified,
      doc_name: localStorage.getItem("AddressRequestNumber"),
      address_type: localStorage.getItem("AddressRequestType"),
      request_type: stageScreen,
    };
    delete payload["communication_address"];
    // if (value.is_corr_and_perm_address_same == "1") {
    //   payload["communication_address"] = {
    //     ...value.permanent_address,
    //     address_line1: verifyAddress.address_line1,
    //     pincode: verifyAddress.pincode,
    //   };
    // }
    try {
      const resp = await updatePermanentAddress(payload);
      console.log("resp", resp);
      setIsLoading(false);
      if (resp.data.message?.status_code !== 200) {
        return toast.error(
          resp.data.message?.message || "Internal server error!"
        );
      }
      toast.success(resp.data.message?.message, "Success");
      handleKra();
    } catch (error) {
      const { data } = error.response || {};
      toast.error(data.message || "Internal server error!");
      setIsLoading(false);
    }
  };

  const handleKra = async (value) => {
    const payload = {
      request_type: stageScreen,
      document_name: localStorage.getItem("AddressRequestNumber"),
      ...value,
    };
    setIsLoading(true);
    try {
      await addAddressKra({
        request_type: stageScreen,
        address_type: localStorage.getItem("AddressRequestType"),
        document_name: localStorage.getItem("AddressRequestNumber"),
        pan_number: activeUserDetail.poi?.[0]?.pan_number,
        dob: activeUserDetail.poi?.[0]?.dob?.split("-").reverse().join("-"),
      });
      setIsLoading(false);
      const requestTypes = getRequestTypeStage();
      const requestTypesDocs = getRequestTypeDocs() || [];
      requestTypesDocs.push(payload.document_name);
      if (requestTypes && requestTypes.length > 0) {
        requestTypes.shift();
        localStorage.setItem("RequestTypeStage", JSON.stringify(requestTypes));
        localStorage.setItem(
          "RequestTypeDocs",
          JSON.stringify(requestTypesDocs)
        );
        Swal.fire({
          title: "Address Modification Request Saved. Thank You..!",
          icon: "success",
          showCloseButton: false,
          showConfirmButton: false,
          timer: 3000,
        });
        if (requestTypes.length === 0) {
          setTimeout(async () => {
            await setStageScreen("MultipleRequestTypes");
          }, 3000);
          return;
        }
        setTimeout(async () => {
          await setStageScreen(requestTypes[0]);
        }, 3000);
        return;
      }
      setStep("AddressModificationReview");
    } catch (error) {
      const { data } = error.response || {};
      toast.error(
        data.message?.message || "Internal server error!"
      );
      setIsLoading(false);
    }
  };

  const getAddressInfo = async (value, setFieldValue, type) => {
    setIsLoading(true);
    let payload = { pincode: value };
    try {
      const resp = await getAddressByPincode(payload);
      const data = resp.data.data;
      setIsLoading(false);
      if (isEmptyObject(data)) return;
      if (type == 1) {
        setFieldValue("permanent_address.city", data.DistrictName);
        setFieldValue("permanent_address.state", data.StateName);
      }
      if (type == 2) {
        setFieldValue("communication_address.city", data.DistrictName);
        setFieldValue("communication_address.state", data.StateName);
      }
    } catch (error) {
      setIsLoading(false);
      if (type == 1) {
        setFieldValue("permanent_address.city", "");
        setFieldValue("permanent_address.state", "");
      }
      if (type == 2) {
        setFieldValue("communication_address.city", "");
        setFieldValue("communication_address.state", "");
      }
    }
  };

  const onSearchPincode = (value, setFieldValue, type) => {
    // 1 for permanent address
    // 2 for communication address
    console.log(type);
    if (type == 1) {
      setFieldValue("permanent_address.pincode", value);
    }
    if (type == 2) {
      setFieldValue("communication_address.pincode", value);
    }
    if (value.length > 5) {
      clearTimeout(timeout.current);
      timeout.current = setTimeout(() => {
        getAddressInfo(value, setFieldValue, type);
      }, 250);
    } else {
      if (type == 1) {
        setFieldValue("permanent_address.city", "");
        setFieldValue("permanent_address.state", "");
      }
      if (type == 2) {
        setFieldValue("communication_address.city", "");
        setFieldValue("communication_address.state", "");
      }
    }
  };

  const getPermanentAddress = (address) => {
    const { city, state } = address;
    let html = [];
    if (city) {
      html.push(
        <span style={{ fontSize: "12px", margin: "0 2px" }}>{city}</span>
      );
    }
    if (state) {
      html.push(
        <span style={{ fontSize: "12px", margin: "0 2px" }}>{state}</span>
      );
    }
    return html;
  };

  return (
    <React.Fragment>
      <Title title="Update Permanent Address" />
      <div className="row">
        <div className="col-md-12">
          <div className="form-group">
            <div className="mb-2">
              <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                validate={handleValidate}
                onSubmit={handleSubmit}
              >
                {({ values, isValid, dirty, isSubmitting, setFieldValue }) => (
                  <Form>
                    {/* <div>
                      <div className="form-group my-2">
                        <p className="m-0 p-0">Permanent Address</p>
                        <p className="m-0 p-0" style={{ fontSize: "12px" }}>
                          Do you wish to update your permanent address.?
                        </p>
                      </div>
                      <div
                        class="form-check form-check-inline"
                        style={{ paddingLeft: 0 }}
                      >
                        <Field
                          type="radio"
                          name="is_address_modified"
                          value="1"
                          checked={values.is_address_modified == "1"}
                          onChange={() => {
                            setStep("AddressProofModification");
                            setFieldValue("is_address_modified", "1");
                          }}
                        />
                        <label class="form-check-label mx-1">Yes</label>
                      </div>
                      <div
                        class="form-check form-check-inline"
                        style={{ paddingLeft: 0 }}
                      >
                        <Field
                          type="radio"
                          name="is_address_modified"
                          value="0"
                          checked={values.is_address_modified == "0"}
                        />
                        <label class="form-check-label mx-1">No</label>
                      </div>
                    </div> */}
                    <div className="card p-2 mt-2">
                      <div className="form-group my-2">
                        <label className="py-1">Permanent Address</label>
                        <Field
                          name="permanent_address.address_line1"
                          placeholder=""
                          className="form-control"
                          as="textarea"
                          onInput={onInputToUpperCase}
                        />
                      </div>
                      <div className="form-group my-2">
                        <label className="py-1">Permanent Pincode</label>
                        <Field
                          name="permanent_address.pincode"
                          placeholder=""
                          className="form-control"
                          onPaste={validateOnPaste}
                          onKeyPress={validateOnNumber}
                          onChange={({ target }) =>
                            onSearchPincode(target.value, setFieldValue, 1)
                          }
                          maxLength="6"
                        />
                      </div>
                      <div className="d-flex">
                        {getPermanentAddress(values.permanent_address)}
                      </div>
                    </div>
                    {/* <div className="card p-2 mt-2">
                      <div className="form-group my-2">
                        <label className="py-1">Communication Address</label>
                        <Field
                          name="communication_address.address_line1"
                          placeholder=""
                          className="form-control"
                          as="textarea"
                          readOnly
                        />
                      </div>
                      <div className="form-group my-2">
                        <label className="py-1">Communication Pincode</label>
                        <Field
                          name="communication_address.pincode"
                          placeholder=""
                          className="form-control"
                          readOnly
                        />
                      </div>
                      <div className="d-flex">
                        {getPermanentAddress(values.communication_address)}
                      </div>
                    </div> */}
                    <div className="d-flex form-group my-4">
                      <div className="mx-2">
                        <Button
                          type="button"
                          title="Back"
                          handleClick={() =>
                            setStep("AddressProofModification")
                          }
                        />
                      </div>
                      <div className="mx-2">
                        <Button
                          type="button"
                          title="Submit"
                          disabled={!isValid || isSubmitting}
                          handleClick={() => setShowModal(true)}
                        />
                      </div>
                    </div>
                    <Modal
                      show={showModal}
                      size="md"
                    >
                      <Modal.Header>
                        <Modal.Title>Permanent Address</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <div>
                          <div className="form-group my-2">
                            <p
                              className="m-0 p-0 text-bold"
                              style={{ fontSize: "16px" }}
                            >
                              Permanent address same as correspondence Address?*
                            </p>
                          </div>
                          <div
                            class="form-check form-check-inline"
                            style={{ paddingLeft: 0 }}
                          >
                            <Field
                              type="radio"
                              name="is_corr_and_perm_address_same"
                              value="1"
                              checked={
                                values.is_corr_and_perm_address_same == "1"
                              }
                            />
                            <label class="form-check-label mx-1">Yes</label>
                          </div>
                          <div
                            class="form-check form-check-inline"
                            style={{ paddingLeft: 0 }}
                          >
                            <Field
                              type="radio"
                              name="is_corr_and_perm_address_same"
                              value="0"
                              checked={
                                values.is_corr_and_perm_address_same == "0"
                              }
                            />
                            <label class="form-check-label mx-1">No</label>
                          </div>
                        </div>
                        <div className="row mt-2">
                          <h5 className="text-bold m-0">
                            Correspondence Address
                          </h5>
                          <div className="row my-1">
                            <div className="col-sm">Address</div>
                            <div className="col-sm">
                              {values.communication_address?.address_line1}
                            </div>
                          </div>
                          <div className="row my-1">
                            <div className="col-sm">City</div>
                            <div className="col-sm">
                              {values.communication_address?.city}
                            </div>
                          </div>
                          <div className="row my-1">
                            <div className="col-sm">State</div>
                            <div className="col-sm">
                              {values.communication_address?.state}
                            </div>
                          </div>
                          <div className="row my-1">
                            <div className="col-sm">Pincode</div>
                            <div className="col-sm">
                              {values.communication_address?.pincode}
                            </div>
                          </div>
                          <div className="row my-1">
                            <div className="col-sm">Country</div>
                            <div className="col-sm">
                              {values.communication_address?.country}
                            </div>
                          </div>
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          type="button"
                          title="Cancel"
                          handleClick={() => {
                            setFieldValue("is_corr_and_perm_address_same", "");
                            setShowModal(false);
                          }}
                        />
                        <Button
                          title="Proceed"
                          disabled={!values.is_corr_and_perm_address_same}
                          handleClick={() => handleSubmit(values)}
                        />
                      </Modal.Footer>
                    </Modal>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default PermanentAddressForm;
